export interface OttoConfig {
  environment: string;
  buildCommit: string;
  apiBaseUrl: string;
  wsBaseUrl: string;
  auth: {
    cognitoHostedUiBaseUrl: string;
    clientId: string;
    identityProvider: string;
    responseType: string;
    scope: string;
  };
}

declare global {
  interface Window {
    __OTTO_CONFIG__?: OttoConfig;
  }
}

export function getConfig(): OttoConfig {
  const config = window.__OTTO_CONFIG__;
  if (!config) {
    // Local dev fallback
    return {
      environment: "local",
      buildCommit: "local",
      apiBaseUrl: "",
      wsBaseUrl: "ws://localhost:3001",
      auth: {
        cognitoHostedUiBaseUrl: "http://localhost:9229",
        clientId: "local-client-id",
        identityProvider: "DRIVE-INC-STAFF-LOGIN",
        responseType: "code",
        scope: "openid email profile",
      },
    };
  }
  return config;
}
